// Batch Auto Tracker.
//
// Same Hold Time Tracker as Batch Tracker, but stage times come from the Area Log
// (equipment_log_books, the data behind Area Log (New)) instead of the Physical Log.
// Rules (Master Rules in Batch Tracker) and ratifications are shared.
import React from 'react';
import { Tabs, Typography } from 'antd';
import HoldTimeTracker from './HoldTimeTracker';

const { Title } = Typography;

const BatchAutoTracker = () => {
  const tabItems = [
    { key: 'hold-time-tracker', label: 'Hold Time Tracker', children: <HoldTimeTracker source="area_log" /> },
  ];

  return (
    <div style={{ padding: '20px 24px', maxWidth: 1600, margin: '0 auto' }}>
      <Title level={3} style={{ marginBottom: 16 }}>Batch Auto Tracker</Title>
      <Tabs defaultActiveKey="hold-time-tracker" items={tabItems} size="large" />
    </div>
  );
};

export default BatchAutoTracker;
